import { render, staticRenderFns } from "./EditBUPage.vue?vue&type=template&id=fcc2cb40&"
import script from "./EditBUPage.vue?vue&type=script&lang=js&"
export * from "./EditBUPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports